import React, {useState} from 'react';

import {ContextualButtonLink} from 'src/components/contextual-link/contextual-button-link';
import {ContextualLinkModal} from 'src/modules/event-create/header-block/contextual-link/contextual-link-modal';
import {ChangeRequestContextualLink} from 'src/openapi/models/ChangeRequestContextualLink';

import {DropdownMenu} from '@pb/kit-component-dropdown-menu';
import {Group, Item} from '@pb/kit-component-group';
import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';

import {contextualLinkError} from './contextual-link.module.styl';

type Props = {
    contextualLink?: ChangeRequestContextualLink,
    onChange: (addedLink: ChangeRequestContextualLink, currantLink?: ChangeRequestContextualLink) => void,
    validationHighLight?: boolean,
    onRemove?: (linkToDelete: ChangeRequestContextualLink) => void,
    disabled?: boolean,
};

export const ContextualLink = (props: Props) => {
    const {
        contextualLink,
        disabled,
        validationHighLight,
        onChange,
        onRemove,
    } = props;
    const [shown, setShown] = useState(false);

    const onClick = () => {
        setShown(true);
    };

    const onClose = () => {
        setShown(false);
    };

    const onChangeLink = (addedLink: ChangeRequestContextualLink, currantLink?: ChangeRequestContextualLink) => {
        onChange(addedLink, currantLink);
        onClose();
    };

    const onRemoveLink = (linkToDelete: ChangeRequestContextualLink) => {
        if (onRemove && linkToDelete) {
            onRemove(linkToDelete);
            onClose();
        }
    };

    return (
        <DropdownMenu
            shown={shown}
            setShown={setShown}
            hideOnBodyLeave={false}
            maxWidth={600}
            anchor={({anchorRef, getAnchorProps}) => (
                <Group {...getAnchorProps()}>
                    {contextualLink ? (
                        <div ref={anchorRef} style={{minWidth: 0, width: '100%'}}>
                            <ContextualButtonLink contextualLink={contextualLink} onClick={onClick}/>
                        </div>
                    ) : (
                        <BasicIconButton
                            className={validationHighLight ? contextualLinkError : ''}
                            ref={anchorRef}
                            iconProps={{type: Icons.ADD_ITEM, size: Sizes.Size_19}}
                            disabled={disabled}
                            onClick={onClick}
                        />
                    )}
                </Group>
            )}>
            <Item style={{width: '40rem'}}>
                <ContextualLinkModal
                    onRemoveLink={onRemoveLink}
                    currentLink={contextualLink}
                    onClose={onClose}
                    onChangeLink={onChangeLink}
                />
            </Item>
        </DropdownMenu>
    );
};
